import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

const ENGLISH = "en";
const FRENCH = "fr";
const ARABIC = "ar";
const FALLBACK_LANGUAGE = ENGLISH;

export const supportedLanguages = [FALLBACK_LANGUAGE, FRENCH, ARABIC];

i18n
  .use(initReactI18next) // Initializes react-i18next
  .use(LanguageDetector) // Detects user language
  .use(HttpBackend) // Load translations via HTTP
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: supportedLanguages,
    ns: "common",
    detection: {
      // Detect from localStorage, cookies, or browser language
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
